// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1tk3C","content":"Consent_content__14gc0","footer":"Consent_footer__umtTE"};